import { OrderPayload } from 'lib/core/data/quote/placeOrder'
import axios, { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { getHeaders } from 'lib/core/services/magento/client/utils'

interface PlaceGuestOrderMutationInput extends OrderPayload {
  cartId: string
}

export type PlaceGuestOrderMutation = (input: PlaceGuestOrderMutationInput) => Promise<AxiosResponse<any>>

export const createPlaceGuestOrderMutation = (deps: ServiceDependencies): PlaceGuestOrderMutation => async ({ payload, cartId }) => {
  return axios.put(`/V1/guest-carts/${cartId}/order`, payload, {
    headers: getHeaders(),
    responseType: 'text'
  })
}
